import React, { useState } from 'react';
import { Paper, TextField, InputAdornment, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import { CenteredFlexBox, ColumnFlexBox } from '../../../Components/FlexBox';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import IconButton from '../../../Components/Button/IconButton';

const AddStageStep = function AddStageStep({
  onSave = () => {},
  cancelEdit,
  minValue,
  isSystem = false,
  defaultValue = { name: '', value: '' },
}) {
  const intl = useIntl();
  const [name, setName] = useState(defaultValue.name);
  const [advancementThreshold, setAdvancementThreshold] = useState(
    defaultValue.value
  );
  const [description, setDescription] = useState(
    defaultValue.description || ''
  );

  const handleChangeName = (event) => {
    setName(event.target.value?.toUpperCase());
  };

  const handleChangeAdvancementThreshold = (event) => {
    setAdvancementThreshold(event.target.value);
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleSave = () => {
    onSave({
      name,
      advancementThreshold: parseInt(advancementThreshold, 10),
      description,
    });
    setName('');
    setAdvancementThreshold('');
    setDescription('');
  };

  return (
    <Paper variant="outlined" sx={{ padding: '16px' }}>
      <CenteredFlexBox gap="8px">
        <ColumnFlexBox gap="8px" flexGrow={1}>
          <CenteredFlexBox gap="16px">
            <TextField
              id="stage-title-txtfield"
              label={intl.messages.STAGE_NAME}
              value={name}
              onChange={handleChangeName}
              sx={{ width: '60%' }}
            />
            <TextField
              id="percentage-value-txtfield"
              type="number"
              disabled={isSystem}
              value={advancementThreshold}
              onChange={handleChangeAdvancementThreshold}
              sx={{ width: '40%' }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <PercentRoundedIcon />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </CenteredFlexBox>
          <CenteredFlexBox gap="16px">
            <TextField
              id="description-txtfield"
              label={intl.messages.DESCRIPTION}
              value={description}
              onChange={handleChangeDescription}
              multiline
              sx={{ width: '70%' }}
            />
            <Button
              id="add-stage-step-btn"
              onClick={handleSave}
              startIcon={cancelEdit ? <EditRoundedIcon /> : <AddRoundedIcon />}
              variant="contained"
              size="large"
              sx={{ minWidth: '164px', width: '30%' }}
              disabled={
                !name ||
                (!isSystem &&
                  (!advancementThreshold ||
                    advancementThreshold <= 0 ||
                    (minValue !== undefined &&
                      advancementThreshold <= minValue)))
              }
            >
              {intl.messages.CONFIRM}
            </Button>
          </CenteredFlexBox>
        </ColumnFlexBox>
        {cancelEdit && (
          <IconButton id="cancel-edit" title="CANCEL_EDIT" onClick={cancelEdit}>
            <CloseRoundedIcon />
          </IconButton>
        )}
      </CenteredFlexBox>
    </Paper>
  );
};

export default AddStageStep;
